import { functionBodyToString } from '@juvare/common-form-ui/WidgetForm/Utils';
export const getAccountExportSettingFormConfig = (defaultAccountFieldTypeValues, settingSourceFieldExclusions) => {
    return {
        type: 'form',
        children: [
            {
                type: 'form.content',
                template: {
                    content: '<div style="display: flex; column-gap: 16px;">\n' +
                        '  <div style="display: flex; flex-direction: column; flex-basis: 50%; gap: 8px; justify-content: center; background-color: #F7F8F9; padding: 16px">\n' +
                        '    <p class="subtitle2" style="margin: 0">Total Fields</p>\n' +
                        '    <h1 style="margin: 0">{{totalFields}}</h1>\n' +
                        '  </div>\n' +
                        '  <div style="display: flex; flex-direction: column; flex-basis: 50%; gap: 8px; justify-content: center; background-color: #F7F8F9; padding: 16px">\n' +
                        '    <p class="subtitle2" style="margin: 0">Standard Export Fields</p>\n' +
                        '    <h1 style="margin: 0">{{defaultFields}}</h1>\n' +
                        '  </div>\n' +
                        '</div>',
                    dataTransform: functionBodyToString((handler) => {
                        const exportFields = handler.getData();
                        return {
                            totalFields: exportFields.length,
                            defaultFields: exportFields.filter((f) => f && f.default).length,
                        };
                    }, 'handler'),
                },
            },
            {
                type: 'form.panel',
                children: [
                    {
                        type: 'form.dataGrid',
                        addButtonLabel: 'Add Field',
                        reorder: true,
                        children: [
                            {
                                type: 'form.panel',
                                children: [
                                    {
                                        type: 'form.panel',
                                        children: [
                                            {
                                                type: 'form.text',
                                                key: 'headerName',
                                                label: 'Header Name',
                                                validate: {
                                                    required: true,
                                                },
                                                style: {
                                                    width: 500,
                                                },
                                            },
                                            {
                                                type: 'form.text',
                                                key: 'source',
                                                label: 'Source',
                                                hidden: {
                                                    when: '^^/type',
                                                    dataIn: settingSourceFieldExclusions !== null && settingSourceFieldExclusions !== void 0 ? settingSourceFieldExclusions : [],
                                                },
                                                style: {
                                                    width: 250,
                                                },
                                            },
                                            {
                                                type: 'form.select',
                                                key: 'type',
                                                label: 'Type',
                                                values: defaultAccountFieldTypeValues,
                                                style: {
                                                    width: 250,
                                                },
                                            },
                                            {
                                                type: 'form.checkbox',
                                                key: 'default',
                                                label: 'Set Standard',
                                                defaultValue: false,
                                                style: {
                                                    type: 'switch',
                                                    paddingTop: 8,
                                                },
                                            },
                                        ],
                                        style: {
                                            layout: 'row',
                                            horizontalAlign: 'left',
                                        },
                                    },
                                    {
                                        type: 'form.divider',
                                    },
                                ],
                            },
                        ],
                    },
                ],
                style: {
                    surface: 'level1',
                },
            },
        ],
    };
};
